import { ILink } from './linksInterfaces';
import { IState } from '..';
import { PermissionTypes } from '../auth';
import orderBy from 'lodash-es/orderBy';

export function getLinks(state: IState, type: PermissionTypes): ILink[] {
  const links = Object.values(state.links.hash).filter(x => x.type === type);
  return orderBy(links, (l: ILink) => l.name.toLowerCase());
}
